// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"640":"d4c5c018803ee8751b2a","780":"ff118c4ea27eb0b2dbdd","2236":"addc2ab85416b1039192","3564":"96b5c5a4b9fcd4b4e70d","4508":"e95d62a7900174fe8769","5258":"7b70fd4441c2b5a0ddbd","5810":"b550a24d46f75f92c2d5","5862":"8bc76a21d9622c29e1a9","7471":"6423b9b898ffefeb7d1d"}[chunkId] + "";
};